<script setup>
const PATHS = {
  store: '<path d="M3 9l1-5h16l1 5M3 9v10h18V9M3 9h18M9 13v6M15 13v6"/>',
  clipboard: '<rect x="6" y="4" width="12" height="16" rx="2"/><path d="M9 4V3a1 1 0 011-1h4a1 1 0 011 1v1M9 10h6M9 14h6"/>',
  truck: '<rect x="1" y="7" width="13" height="9"/><path d="M14 10h4l3 3v3h-7z"/><circle cx="5.5" cy="18" r="1.6"/><circle cx="17.5" cy="18" r="1.6"/>',
  boxes: '<path d="M3 9l6-3 6 3-6 3-6-3zM3 9v6l6 3M15 9v6l-6 3M15 9l6-3v6l-6 3"/>',
  alert: '<path d="M12 3l9 16H3z"/><path d="M12 10v4M12 17h.01"/>',
  target: '<circle cx="12" cy="12" r="9"/><circle cx="12" cy="12" r="5"/><circle cx="12" cy="12" r="1"/>',
  trending: '<path d="M3 17l6-6 4 4 8-8M17 7h4v4"/>',
  award: '<circle cx="12" cy="8" r="5"/><path d="M8.5 12.5L7 21l5-3 5 3-1.5-8.5"/>',
  chart: '<path d="M4 20V10M11 20V4M18 20v-7"/><path d="M2 20h20"/>',
  compass: '<circle cx="12" cy="12" r="9"/><path d="M15 9l-2 6-6 2 2-6z"/>',
  megaphone: '<path d="M3 10v4h3l8 4V6l-8 4H3z"/><path d="M17 9a3 3 0 010 6"/>',
  calendar: '<rect x="3" y="5" width="18" height="16" rx="2"/><path d="M16 3v4M8 3v4M3 10h18"/>',
  bell: '<path d="M18 8a6 6 0 10-12 0c0 7-3 8-3 8h18s-3-1-3-8"/><path d="M10 20a2 2 0 004 0"/>',
  file: '<path d="M6 2h9l5 5v15H6z"/><path d="M15 2v5h5"/>',
  pill: '<rect x="3" y="9" width="18" height="6" rx="3" transform="rotate(-25 12 12)"/><path d="M9 9l6 6" transform="rotate(-25 12 12)"/>',
  briefcase: '<rect x="2" y="7" width="20" height="13" rx="2"/><path d="M8 7V5a2 2 0 012-2h4a2 2 0 012 2v2"/>',
  users: '<circle cx="9" cy="8" r="3.5"/><path d="M2 20c0-4 3-6 7-6s7 2 7 6M16 8.5a3 3 0 110-6M17 14c3 .3 5 2.2 5 6"/>',
  phone: '<path d="M5 4h4l1.5 5-2.5 2a12 12 0 006 6l2-2.5 5 1.5v4a2 2 0 01-2 2C10 22 2 14 2 6a2 2 0 012-2z"/>',
  link: '<path d="M9 15l6-6"/><path d="M10 6l1-1a4 4 0 116 6l-1 1M14 18l-1 1a4 4 0 11-6-6l1-1"/>',
  shield: '<path d="M12 2l8 4v6c0 5-3.5 8.5-8 10-4.5-1.5-8-5-8-10V6z"/>',
  chevronDown: '<path d="M6 9l6 6 6-6"/>',
  logout: '<path d="M9 21H5a2 2 0 01-2-2V5a2 2 0 012-2h4M16 17l5-5-5-5M21 12H9"/>',
}
const props = defineProps({ name: { type: String, required: true }, size: { type: [Number, String], default: 16 } })
</script>

<template>
  <svg :width="size" :height="size" viewBox="0 0 24 24" fill="none" stroke="currentColor"
       stroke-width="1.8" stroke-linecap="round" stroke-linejoin="round"
       v-html="PATHS[name] || PATHS.file" />
</template>
